import script from "./InvestigationReportTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestigationReportTable.vue?vue&type=script&setup=true&lang=js"

import "./InvestigationReportTable.vue?vue&type=style&index=0&id=a799c47a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a799c47a"]])

export default __exports__